<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title"> {{ 'PRESET.CREATE_PRESET' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm btn-back" (click)="backTo()">
                        <!-- <i class="bi bi-arrow-left-square"></i> -->
                        {{ 'BACK' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onCreate()" [disabled]="form.invalid || !ffInputLang.valid || attributesElements.length == 0">
                        <!-- <i class="bi bi-save"></i>  -->
                        {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                    <div class="row">

                        <div class="col-6">
                            <div class="form-group">
                                <ff-input-lang
                                    label="{{ 'PRESET.NAME_PRESET' | translate }}"
                                    hint="{{ 'PRESET.SPECIFY_PRESET_NAME_IN_ALL_LANGUAGES' | translate }}"
                                    fieldId="name"
                                    fieldName="name"
                                    fieldType="text"
                                    [clearField]="ffInputLangParams.name.clearField"
                                    [required]="ffInputLangParams.name.required"
                                    [inputValue]="attributeName" 
                                    (changeValue)="eventFnFF('name', $event)">
                                </ff-input-lang>
                            </div>
                        </div>

                        <div class="col-6" *ngIf="permissionAccess.check('REFERENCES_ATTRS_PRESET_TYPES')">
                            <div class="form-group">
                                <label class="filter-label" for="attribute_id"> {{ 'PRESET.TYPE_PRESET' | translate }}:</label>
                                <ng-select 
                                class="custom" 
                                clearAllText="{{ 'CLEAN' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="type" 
                                [multiple]="false" 
                                [items]="attributePresetTypes">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="form-group checkbox">
                                <input 
                                class="form-check-input" 
                                #conditionalCheckbox  
                                type="checkbox" 
                                formControlName="conditional"
                                [checked]="form.get('conditional').value" 
                                (change)="checkCondtitional(conditionalCheckbox.checked)">
                                <label class="form-check-label"> {{ 'PRESET.ADD_CONDITION_FOR_DISPLAYING_PRESET' | translate }}</label>
                            </div>
                        </div>

                        <div class="col-12" *ngIf="form.get('conditional').value" formArrayName="selectors">

                            <div *ngFor="let item of form.get('selectors')['controls']; let i = index;">
            
                                <div class="row" [formGroupName]="i">

                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="filter-label" for="attribute_id"><span class="star">*</span> {{ 'ATTRIBUTE' | translate }}:</label>
                                            <ng-select 
                                            id="attribute_group_id" 
                                            class="custom" 
                                            clearAllText="{{ 'CLEAN' | translate }}"
                                            notFoundText="{{ 'NO_DATA' | translate }}" 
                                            bindLabel="name" 
                                            bindValue="id"
                                            formControlName="attribute_id" 
                                            [multiple]="false" 
                                            [items]="attributeForPresets"
                                            (change)="setAttrValues($event, i)">
                                            </ng-select>
                                        </div>
                                    </div>

                                    <!-- IF COMBOBOX_MULTIPLE (select)-->
                                    <div [ngClass]="form.get('selectors').value.length > 1 ? 'col-5 form-group' : 'col-6 form-group'">
                                        <div *ngIf="item.controls?.attr_present_type_id.value == attrType.combobox_multiple">
                                            <div class="form-group">
                                                <label for="attribute_value"><span class="star">*</span> {{ 'PRESET.VALUE_ATTRIBUTE' | translate }}:</label>    
                                                    <ng-select 
                                                    class="custom" 
                                                    clearAllText="{{ 'CLEAN' | translate }}" 
                                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                                    bindLabel="name" 
                                                    bindValue="id" 
                                                    formControlName="attribute_value"
                                                    placeholder="{{ 'PRESET.CHOOSE_ESOLUTION' | translate }}"
                                                    [multiple]="true"
                                                    [loading]="loading" 
                                                    [closeOnSelect]="false"
                                                    [items]="item.controls.value_query.value">
                                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                                            <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                                                            <span>{{item.name}}</span>
                                                    </ng-template>
                                                </ng-select>                                                
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div [ngClass]="form.get('selectors').value.length > 1 ? 'col-5 form-group' : 'col-6 form-group'">
                                        <div *ngIf="item.controls?.attr_present_type_id.value == attrType.combobox_multiple">
                                            <label class="filter-label" for="attribute_id"><span class="star">*</span> Значения атрибута:</label>
                                            <app-editable-content 
                                            [inputValue]="{presetContentType: item.controls?.attr_present_type_id.value, contentValue: item.controls.value_query.value, actions: false}"
                                            (outputValue)="getOutPutValue($event, i)">
                                            </app-editable-content>
                                        </div>
                                    </div> -->
                                    <div class="col-1">
                                        <div class="remove-selector-field" *ngIf="form.get('selectors').value.length > 1">
                                            <button type="button" class="btn btn-danger" (click)="removePresetField(i)"> 
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                   
                    <div class="row">
                        <div class="col-12">
                            <div class="add-selector-field" *ngIf="form.get('conditional').value">
                                <button type="button" class="btn btn-primary btn-sm" (click)="addConditionalFields()"> 
                                    <i class="bi bi-plus-circle"></i> {{ 'ADD_CONDITION' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-6" *ngIf="permissionAccess.check('REFERENCES_ORGANIZATIONS')">
                                <div class="form-group">
                                    <label class="filter-label"> {{ 'ORGANIZATION.ORGANIZATION' | translate }}:</label>
                                    <ng-select 
                                    id="attr_present_type_id" 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                    bindLabel="name" 
                                    bindValue="id"
                                    formControlName="org_id" 
                                    [multiple]="false" 
                                    [items]="organizations">
                                    </ng-select>
                                </div>
                            </div>
                    </div> 

                    <div class="row">
                        <div class="col-12">
                            <div class="add-preset-element-field">
                                <button type="button" class="btn btn-primary btn-sm" (click)="addElement(null, attributesElements.length, 'create')"> 
                                    <i class="bi bi-plus-circle"></i> {{ 'PRESET.ADD_ATTRIBUTES' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col" class="attribute"> {{ 'ATTRIBUTE' | translate }}</th>
                                <th scope="col" class="group"> {{ 'GROUP' | translate }}</th>
                                <th scope="col" class="attributeValueType"> {{ 'PRESET.TYPE_VALUE_ATTRIBUTES' | translate }}</th>
                                <th scope="col" class="attrPresentType"> {{ 'TYPE_ATTRIBUTE' | translate }}</th>
                                <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                            </tr>
                        </thead>
    
                        <tbody *ngIf="attributesElements && attributesElements.length > 0">
                            <tr *ngFor="let attributesElement of attributesElements; let j = index;">
                                <td class="name">{{attributesElement.attribute_name}}</td>
                                <td class="group">{{ attributesElement.attribute_group_name }}</td>
                                <td class="attributeValueType">{{ attributesElement.attribute_value_type }}</td>
                                <td class="attrPresentType">{{ attributesElement.attr_present_type_id }}</td>
                                <td class="action">
                                    <button type="button" class="btn btn-light" (click)="addElement(attributesElement, j, 'edit')"
                                        placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                        <i class="bi bi-pencil-square"></i>
                                    </button>
                                    <button type="button" class="btn btn-light" (click)="onDelete(i)"
                                        placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                        <i class="bi bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>

            </div>
        </div>
    </div>
</div>